const QUOTATION_STATUS_LABELS = {
  draft: 'Borrador',
  sent: 'Enviada',
  accepted: 'Aceptada',
  rejected: 'Rechazada',
  deleted: 'Eliminada',
};

const normalizeQuotationStatus = (status) => String(status || '').trim().toLowerCase();

const isDraftQuotationStatus = (status) => normalizeQuotationStatus(status) === 'draft';

const isImmutableQuotationStatus = (status) => (
  !isDraftQuotationStatus(status)
);

const resolveQuotationListDeletedFilter = ({ includeDeleted = false, status } = {}) => (
  includeDeleted || normalizeQuotationStatus(status) === 'deleted' ? undefined : false
);

const getQuotationStatusLabel = (status) => {
  if (!status) return 'Sin estado';
  const normalized = normalizeQuotationStatus(status);
  return QUOTATION_STATUS_LABELS[normalized] || status;
};

export {
  QUOTATION_STATUS_LABELS,
  getQuotationStatusLabel,
  isDraftQuotationStatus,
  isImmutableQuotationStatus,
  resolveQuotationListDeletedFilter,
};
